import { mapFields } from "vuex-map-fields";
import i18n from "@/i18n";
export default {
  computed: {
    canUserViewPartsAndRepairtimes() {
      if (this.isOwnerOfActiveShop() === true) return true;
      return this.$store.getters["auth/canCurrentUser"](
        "parts_and_repairtimes|view"
      );
    },
    canUserViewConfig() {
      if (this.isOwnerOfActiveShop() === true) return true;
      return this.$store.getters["auth/canCurrentUser"]("config|view");
    },
    canUserFullConfig() {
      if (this.isOwnerOfActiveShop() === true) return true;
      return this.$store.getters["auth/canCurrentUser"]("config|full");
    },
    /**
     * Проверка есть ли у shop пользователя тарифный план
     * @returns {boolean}
     */
    isHavingTarrifplan() {
      if( ! this.authenticatedUser) return false;
      if( ! this.authenticatedUser.shop) return false;
      if( ! this.authenticatedUser.shop.is_active) return false;
      return !!(
        this.authenticatedUser.shop &&
        this.authenticatedUser.shop.tarrifplan &&
        this.authenticatedUser.shop.tarrifplan.ability
      );
    },
    ...mapFields("auth", ["authenticatedUser"]),
  },
  methods: {
    tarrifplanHasAbility(nameWithRight) {
      if (!nameWithRight || !this.isHavingTarrifplan) return false;
      //        can_send_sms_to_customers
      let name = nameWithRight.split("|")[0];
      //        can_use_catalogs
      //        max_posts_count
      //        max_suppliers_count
      //        max_users_online_count
      //        max_franchisee_count
      switch (name) {
        case "can_use_catalogs":
          return (
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability.can_use_catalogs
            ) === 1
          );
        case "manage_shops":
          return (
            this.authenticatedUser.shop.tarrifplan.ability
              .max_franchisee_count > 0
          );
        case "aftermarket":
          return (
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability.can_use_am_crosses
            ) === 1
          );
        case "storages":
          return (
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability.can_use_storage
            ) === 1
          );
        case "calendar":
          return (
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability.can_use_calendar
            ) === 1
          );
        case "all_orders":
          return true;
        case "can_use_search":
          return (
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability
                .can_use_full_repairtimes
            ) === 1 ||
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability
                .can_use_simple_repairtimes
            ) === 1 ||
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability.can_use_search
            ) === 1
          );
        case "parts_and_repairtimes":
          return (
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability
                .can_use_full_repairtimes
            ) === 1 ||
            parseInt(
              this.authenticatedUser.shop.tarrifplan.ability
                .can_use_simple_repairtimes
            ) === 1
          );
      }

      return true;
    },
    userHasRight(rightName) {
      if (this.tarrifplanHasAbility(rightName) === false) return false;
      switch (rightName) {
        case "manage_shops":
          return (
            this.authenticatedUser.is_owner &&
            parseInt(this.authenticatedUser.owner.shops_limit) > 1
          );
          break;
        case "can_use_search":
          return this.tarrifplanHasAbility(rightName);
          break;
      }
      if (this.isOwnerOfActiveShop() === true) return true;
      return rightName
        ? this.$store.getters["auth/canCurrentUser"](rightName)
        : false;
    },
    isOwnerOfActiveShop() {
      if (this.authenticatedUser.is_owner) {
        let shop = this.authenticatedUser.shops.find(
          (shop) =>
            parseInt(shop.id) ===
            parseInt(this.authenticatedUser.active_shop_id)
        );
        if (
          shop &&
          parseInt(shop.owner_id) ===
            parseInt(this.authenticatedUser.owner.id) &&
          parseInt(this.authenticatedUser.id) ===
            parseInt(this.authenticatedUser.owner.user_id)
        ) {
          return true;
        }
      }
    },
    isOwnerOfShop(shop) {
      if (
        shop &&
        parseInt(shop.owner_id) === parseInt(this.authenticatedUser.owner.id) &&
        parseInt(this.authenticatedUser.id) ===
          parseInt(this.authenticatedUser.owner.user_id)
      ) {
        return true;
      }
      return false;
    },
  },
};
